export const AutomatedNotification = `AutomatedNotification/`;
export const CreateAutomatedNotificationRule = AutomatedNotification + 'Notification/Create';
export const UpdateAutomatedNotificationRule = AutomatedNotification + 'Notification';
export const GetAllAutomatedNotificationRules = AutomatedNotification + 'Notification/All';
export const SearchAutomatedNotificationRules = AutomatedNotification + 'Notification/Search';
export const DeleteAutomatedNotificationRules = AutomatedNotification + 'Notification';
export const GetById = AutomatedNotification + 'Notification';